import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth AuthContext daxilində istifadə edilməlidir');
  }
  return context;
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return 'Xəta baş verdi. Yenidən cəhd edin.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(' ');
  if (detail && typeof detail.message === 'string') return detail.message;
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const { data } = await axios.get(`${BACKEND_URL}/api/auth/me`, {
        withCredentials: true,
      });
      setUser(data);
    } catch (err) {
      setUser(false);
    } finally {
      setLoading(false);
    }
  };

  const register = async (payload) => {
    try {
      setError(null);
      const { data } = await axios.post(
        `${BACKEND_URL}/api/auth/register`,
        payload,
        { withCredentials: true }
      );
      setUser(data);
      return { success: true };
    } catch (e) {
      const detail = e.response?.data?.detail;
      const errMsg = formatApiErrorDetail(detail) || e.message;
      const matchedFields = (detail && typeof detail === 'object' && Array.isArray(detail.matched_fields))
        ? detail.matched_fields
        : [];
      setError(errMsg);
      return { success: false, error: errMsg, matched_fields: matchedFields };
    }
  };

  const login = async (email, password) => {
    try {
      setError(null);
      const { data } = await axios.post(
        `${BACKEND_URL}/api/auth/login`,
        { email, password },
        { withCredentials: true }
      );
      setUser(data);
      return { success: true };
    } catch (e) {
      const errMsg = formatApiErrorDetail(e.response?.data?.detail) || e.message;
      setError(errMsg);
      return { success: false, error: errMsg };
    }
  };

  const logout = async () => {
    try {
      await axios.post(`${BACKEND_URL}/api/auth/logout`, {}, { withCredentials: true });
      setUser(false);
    } catch (e) {
      console.error('Çıxış xətası:', e);
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, error, register, login, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
};